import { useEffect } from "react";
import { useAuth } from "@clerk/clerk-react";

import { setHttpAuthTokenGetter } from "@/shared/lib/api/http";

export function HttpAuthSync() {
  const { getToken, isLoaded, isSignedIn } = useAuth();

  useEffect(() => {
    if (!isLoaded || !isSignedIn) {
      setHttpAuthTokenGetter(null);
      return;
    }

    setHttpAuthTokenGetter(async (options) => {
      return (await getToken({ skipCache: options?.skipCache ?? false })) ?? null;
    });
  }, [getToken, isLoaded, isSignedIn]);

  return null;
}
